'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Quotation;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function Quotation(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: (0, _classnames2.default)('icon-svg-quotation', className), width: width, height: height, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M7.124 2.925c-.445.119-.942.349-1.491.69a9.135 9.135 0 0 0-1.537 1.202c-.474.46-.86.958-1.157 1.492-.297.534-.416 1.069-.356 1.603.059.208.222.326.49.356.267.03.519.045.756.045.742 0 1.388.245 1.937.734.55.49.824 1.18.824 2.07 0 .862-.304 1.604-.913 2.227-.608.624-1.299.935-2.07.935-1.188 0-2.086-.43-2.694-1.291C.304 12.128 0 11.073 0 9.827c0-.98.2-1.923.601-2.828.4-.905.928-1.73 1.58-2.471.654-.742 1.41-1.38 2.272-1.915A8.67 8.67 0 0 1 7.124 1.5v1.425zm8.876 0c-.445.119-.942.349-1.492.69a9.135 9.135 0 0 0-1.536 1.202c-.475.46-.86.958-1.158 1.492-.296.534-.415 1.069-.356 1.603.06.208.223.326.49.356.267.03.52.045.757.045.742 0 1.388.245 1.937.734.55.49.824 1.18.824 2.07 0 .862-.305 1.604-.913 2.227-.609.624-1.299.935-2.07.935-1.188 0-2.086-.43-2.695-1.291-.608-.86-.912-1.915-.912-3.161 0-.98.2-1.923.6-2.828.402-.905.928-1.73 1.582-2.471.653-.742 1.41-1.38 2.27-1.915A8.67 8.67 0 0 1 16 1.5v1.425z' })
  );
}

Quotation.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Quotation/Quotation.js
// module id = 1267
// module chunks = 1